module.exports = __webpack_public_path__ + "img/Frame_1.60357de3.png";